import React, { useEffect, useState } from "react";
import { fetchPaymentHistory } from "../../../services/profile/PaymentHistoryService"; // Adjusted import
import { Pagination } from "antd"; // Import Pagination from Ant Design
import PaymentOptions from "../../Payment/PaymentOptions";

const StudentsPaymentHistory = ({ userId }) => {
	const [payments, setPayments] = useState([]);
	const [currentPageDue, setCurrentPageDue] = useState(1);
	const [currentPagePaid, setCurrentPagePaid] = useState(1);
	const [isModalVisible, setModalVisible] = useState(false);

	const paymentsPerPage = 6; // Number of payments per page

	useEffect(() => {
		const fetchPayments = async () => {
			try {
				const paymentData = await fetchPaymentHistory(userId);
				setPayments(paymentData);
			} catch (error) {
				console.error("Error fetching payment history:", error);
			}
		};

		fetchPayments();
	}, [userId]);

	const duePayments = payments.filter(
		(payment) =>
			// payment.status.toLowerCase() === "pending" ||
			payment.status.toLowerCase() === "overdue" ||
			payment.status.toLowerCase() === "trial" ||
			payment.status.toLowerCase() === "not verified"
	);
	const paidPayments = payments.filter(
		(payment) =>
			payment.status.toLowerCase() === "success" ||
			payment.status.toLowerCase() === "complete" ||
			payment.status.toLowerCase() === "completed"
	);

	const startIndexDue = (currentPageDue - 1) * paymentsPerPage;
	const endIndexDue = startIndexDue + paymentsPerPage;
	const currentDuePayments = duePayments.slice(startIndexDue, endIndexDue);

	const startIndexPaid = (currentPagePaid - 1) * paymentsPerPage;
	const endIndexPaid = startIndexPaid + paymentsPerPage;
	const currentPaidPayments = paidPayments.slice(
		startIndexPaid,
		endIndexPaid
	);

	const handlePageChangeDue = (page) => setCurrentPageDue(page);
	const handlePageChangePaid = (page) => setCurrentPagePaid(page);

	return (
		<div className="max-w-4xl mx-auto my-8 font-sans p-6 bg-white rounded-lg shadow-lg">
			<h2 className="text-3xl font-bold text-gray-800 mb-6">
				Payment History
			</h2>

			{/* Due Payments Section */}
			<div className="mb-8">
				<h3 className="text-2xl font-semibold text-gray-700 mb-4">
					Pending Payments
				</h3>
				{currentDuePayments.length > 0 ? (
					<div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
						{currentDuePayments.map((payment) => (
							<>
								<div
									key={payment._id}
									className="flex justify-between items-center mb-3 last:mb-0"
								>
									<div>
										<p className="font-medium text-gray-800">
											{
												payment.classroomId?.courseId
													?.name
											}
										</p>
										<p className="text-sm text-gray-600">
											Date:{" "}
											{new Date(
												payment.paymentDate
											).toLocaleDateString()}
										</p>
									</div>
									<div className="flex gap-2 ">
										<div className="text-right">
											<p className="font-bold text-gray-800">
												${payment.amount}
											</p>
											<p className="text-sm text-gray-600">
												Status: {payment.status}
											</p>
										</div>
										<div className="flex justify-center">
											<button
												onClick={() => {
													setModalVisible(true);
												}}
												className="sm:text-lg px-3 underline hover:text-blue-600"
											>
												Pay
											</button>
										</div>
									</div>
								</div>
								<PaymentOptions
									isModalVisible={isModalVisible}
									setModalVisible={setModalVisible}
									selectedClassroom={
										payment?.classroomId?._id
									}
									user={{ _id: userId }}
									course={payment?.classroomId?.courseId}
									key={payment._id}
								/>
							</>
						))}
					</div>
				) : (
					<p className="text-green-600 font-medium">
						No due payments. You're all caught up!
					</p>
				)}

				{/* Pagination for Due Payments */}
				<Pagination
					current={currentPageDue}
					total={duePayments.length}
					pageSize={paymentsPerPage}
					onChange={handlePageChangeDue}
					className="mt-4 flex justify-center"
				/>
			</div>

			{/* Past Payments Section */}
			<div>
				<h3 className="text-2xl font-semibold text-gray-700 mb-4">
					Past Payments
				</h3>
				<div className="bg-gray-50 rounded-lg overflow-hidden">
					<table className="min-w-full divide-y divide-gray-200">
						<thead className="bg-gray-100">
							<tr>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Date
								</th>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Course
								</th>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Amount
								</th>
								<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
									Status
								</th>
							</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
							{currentPaidPayments.map((payment) => (
								<tr key={payment._id}>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
										{new Date(
											payment.paymentDate
										).toLocaleDateString()}
									</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
										{payment.classroomId?.courseId?.name}
									</td>
									<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
										${payment.amount}
									</td>
									<td className="px-6 py-4 whitespace-nowrap">
										<span
											className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
												payment.status.toLowerCase() ===
													"success" ||
												payment.status.toLowerCase() ===
													"complete" ||
												payment.status.toLowerCase() ===
													"completed"
													? "bg-green-100 text-green-800"
													: "bg-red-100 text-red-800"
											}`}
										>
											{payment.status}
										</span>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				{/* Pagination for Paid Payments */}
				<Pagination
					current={currentPagePaid}
					total={paidPayments.length}
					pageSize={paymentsPerPage}
					onChange={handlePageChangePaid}
					className="mt-4 flex justify-center"
				/>
			</div>
		</div>
	);
};

export default StudentsPaymentHistory;
